import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { getFormattedErr } from 'src/helpers';
import ApiClient from 'src/helpers/apiClient';
import {
  setIsLeaderboardLoading,
  setIsUpdatingLeaderboard,
} from '../slices/leaderboard';

export const fetchLeaderboard = createAsyncThunk(
  'fetch/leaderboard',
  async (
    {
      page,
      pageSize,
      skillId,
      userSearchQuery,
      showLoader,
      isUpdating,
      showUserRank,
    }: {
      page?: number;
      pageSize?: number;
      skillId?: string;
      userSearchQuery?: string;
      showLoader?: boolean;
      isUpdating?: boolean;
      showUserRank?: boolean;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      if (!skillId) {
        const message = 'Please select a skill to view the leaderboard.';
        enqueueSnackbar(message);
        return rejectWithValue(message);
      }
      if (showLoader) {
        if (isUpdating) {
          dispatch(setIsUpdatingLeaderboard(true));
        } else {
          dispatch(setIsLeaderboardLoading(true));
        }
      }
      const res = await (
        await ApiClient.getUserApi()
      ).userApiGetLeaderboardByUser({
        page,
        pageSize,
        showUserRank,
        skillId,
        userSearchQuery,
      });
      return res.data;
    } catch (err: any) {
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error));
      return rejectWithValue(err.response.data);
    } finally {
      if (showLoader) {
        if (isUpdating) {
          dispatch(setIsUpdatingLeaderboard(false));
        } else {
          dispatch(setIsLeaderboardLoading(false));
        }
      }
    }
  },
);

export const fetchSkillsLeaders = createAsyncThunk(
  'fetch/skillLeaders',
  async (
    {
      skillId,
      userSearchQuery,
    }: {
      skillId?: string;
      userSearchQuery?: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const res = await (
        await ApiClient.getUserApi()
      ).userApiGetLeaderboardByUser({
        page: 1,
        pageSize: 10,
        skillId,
        userSearchQuery,
      });
      return res.data;
    } catch (err: any) {
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error));
      return rejectWithValue(err.response.data);
    }
  },
);

export const followUser = createAsyncThunk(
  'post/follow-user',
  async (userId: string, { rejectWithValue }) => {
    try {
      const response = await (
        await ApiClient.getUserApi()
      ).userApiAddFollowedUsers({ followedUserId: userId });

      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const unfollowUser = createAsyncThunk(
  'post/unfollow-user',
  async (userId: string, { rejectWithValue }) => {
    try {
      const response = await (
        await ApiClient.getUserApi()
      ).userApiRemoveFollowedUsers({ followedUserId: userId });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data);
    }
  },
);
